/* HTTP-клиент API: cookie-сессия, JSON, понятные ошибки на русском. */

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly code?: string,
  ) {
    super(message);
  }
}

type Query = Record<string, string | number | boolean | null | undefined>;

function qs(query?: Query): string {
  if (!query) return "";
  const p = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
  });
  const s = p.toString();
  return s ? "?" + s : "";
}

let onUnauthorized: (() => void) | null = null;

/** Сессия истекла — приложение перекинет на вход. */
export function setUnauthorizedHandler(fn: () => void): void {
  onUnauthorized = fn;
}

async function request<T>(method: string, path: string, body?: unknown, query?: Query): Promise<T> {
  let res: Response;
  try {
    res = await fetch("/api" + path + qs(query), {
      method,
      credentials: "same-origin",
      headers: body instanceof FormData || body === undefined ? undefined : { "content-type": "application/json" },
      body: body instanceof FormData ? body : body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, "Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.", "network");
  }
  if (res.status === 401 && !path.startsWith("/auth/") && !path.startsWith("/public/")) onUnauthorized?.();
  const text = await res.text();
  let data: unknown = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  if (!res.ok) {
    const err = (data && typeof data === "object" ? data : {}) as { error?: string; code?: string };
    throw new ApiError(res.status, err.error || "Ошибка " + res.status, err.code);
  }
  return data as T;
}

export const api = {
  get: <T>(path: string, query?: Query) => request<T>("GET", path, undefined, query),
  post: <T>(path: string, body?: unknown) => request<T>("POST", path, body ?? {}),
  put: <T>(path: string, body?: unknown) => request<T>("PUT", path, body ?? {}),
  patch: <T>(path: string, body?: unknown) => request<T>("PATCH", path, body ?? {}),
  del: <T>(path: string) => request<T>("DELETE", path),
  upload: <T>(path: string, form: FormData) => request<T>("POST", path, form),
};

export function errorText(e: unknown): string {
  if (e instanceof ApiError) return e.message;
  if (e instanceof Error) return e.message;
  return "Что-то пошло не так";
}

/** Скачивание файла с сервера (CSV) через временную ссылку. */
export function download(path: string): void {
  const a = document.createElement("a");
  a.href = "/api" + path;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
